import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomerInfo, LocationInfo, RentalInfo, RentalObjectPosition, RentalStatus, TrailerPositionProbability, ComponentBase } from 't4core';
import { RentalDialog } from '../../../../t4common/';


@Component({
    styleUrls: ['./bookingOverview.css'],
    selector: 't4-oneway-bookingOverview',
    templateUrl: './bookingOverview.html',
})
export class BookingOverviewComponent extends ComponentBase implements OnInit {

    constructor() {
        super();

        this.Api.get<number[]>('Util/GetWeeks', { n: 10 }).then(x => {
            this.weeks = x;
        });
    }

    // Data
    public _locationId: number;
    public location: LocationInfo = new LocationInfo();
    public _weekId: number;
    @Input() set locationId(value: number) {
        if (value != this._locationId) {
            this._locationId = value;
            this.Api.get<LocationInfo>("Location/GetLocationInfo", { locationId: this._locationId }).then(x => {
                this.location = x;
                this.loadData();
            });
        }
    }

    @Input() set weekId(value: number) {
        if (value != this._weekId) {
            this._weekId = parseInt(value.toString());;
            this.loadData();
        }
    }

    @Output() public customerActivated = new EventEmitter<CustomerInfo>();
    @Output() public bookingActivated = new EventEmitter<RentalInfo>();

    private weeks: number[] = [];
    private bookings: RentalInfo[] = [];
    public disclosed: RentalInfo[] = [];
    private trailers: RentalObjectPosition[] = [];

    public objectTypes = [421, 422, 340, 423];

    // View data
    public xlBookings: RentalInfo[] = [];
    public lBookings: RentalInfo[] = [];
    public mBookings: RentalInfo[] = [];
    public sBookings: RentalInfo[] = [];

    public xlTrailers: RentalObjectPosition[] = [];
    public lTrailers: RentalObjectPosition[] = [];
    public mTrailers: RentalObjectPosition[] = [];
    public sTrailers: RentalObjectPosition[] = [];

    public xlConfirmableCount: number = 0;
    public lConfirmableCount: number = 0;
    public mConfirmableCount: number = 0;
    public sConfirmableCount: number = 0;

    private activeCustomer: CustomerInfo;
    private activeBooking: RentalInfo;

    public isLoading: boolean = false;

    // Filters
    public trailerTypes: FormControl = new FormControl(this.objectTypes);

    public ngOnInit() {
    }

    private async loadData() {
        if (this.isLoading || !this._weekId || this._weekId < 201901 || !this._locationId) return;
        this.isLoading = true;

        // Clear data
        this.xlBookings = [];
        this.lBookings = [];
        this.mBookings = [];
        this.sBookings = [];

        this.xlTrailers = [];
        this.lTrailers = [];
        this.mTrailers = [];
        this.sTrailers = [];

        this.bookings = await this.Api.get<RentalInfo[]>("OneWay/GetBookingQueue", { locationId: this._locationId, weekId: this._weekId, objectTypes: 0 });
        this.xlBookings = this.bookings.filter(x => x.PrimaryObjectTypeId == 423).sort((a, b) => (a.QueueIndex < b.QueueIndex) ? -1 : 1);
        this.lBookings = this.bookings.filter(x => x.PrimaryObjectTypeId == 340).sort((a, b) => (a.QueueIndex < b.QueueIndex) ? -1 : 1);
        this.mBookings = this.bookings.filter(x => x.PrimaryObjectTypeId == 422).sort((a, b) => (a.QueueIndex < b.QueueIndex) ? -1 : 1);
        this.sBookings = this.bookings.filter(x => x.PrimaryObjectTypeId == 421).sort((a, b) => (a.QueueIndex < b.QueueIndex) ? -1 : 1);

        this.trailers = await this.Api.get<RentalObjectPosition[]>("OneWay/GetTrailerPositions", { locationId: this._locationId, weekId: this._weekId, objectTypes: 0 });
        this.xlTrailers = this.trailers.filter(x => x.RentalObjectTypeId == 423).sort((a, b) => this.sortTrailers(a, b));
        this.lTrailers = this.trailers.filter(x => x.RentalObjectTypeId == 340).sort((a, b) => this.sortTrailers(a, b));
        this.mTrailers = this.trailers.filter(x => x.RentalObjectTypeId == 422).sort((a, b) => this.sortTrailers(a, b));
        this.sTrailers = this.trailers.filter(x => x.RentalObjectTypeId == 421).sort((a, b) => this.sortTrailers(a, b));

      var disabled = await this.Api.get<RentalObjectPosition[]>("OneWay/GetDisabledTrailers", { locationId: this._locationId });
      disabled.filter(x => x.RentalObjectTypeId == 423).map(x => this.xlTrailers.push(x));
      disabled.filter(x => x.RentalObjectTypeId == 340).map(x => this.lTrailers.push(x));
      disabled.filter(x => x.RentalObjectTypeId == 422).map(x => this.mTrailers.push(x));
      disabled.filter(x => x.RentalObjectTypeId == 421).map(x => this.sTrailers.push(x));

        this.xlConfirmableCount = this.xlTrailers.filter(x => x.Probability == TrailerPositionProbability.AtStation).length - this.xlBookings.filter(x => x.Status == RentalStatus.ReservedAndBound).length;
        this.lConfirmableCount = this.lTrailers.filter(x => x.Probability == TrailerPositionProbability.AtStation).length - this.lBookings.filter(x => x.Status == RentalStatus.ReservedAndBound).length;
        this.mConfirmableCount = this.mTrailers.filter(x => x.Probability == TrailerPositionProbability.AtStation).length - this.mBookings.filter(x => x.Status == RentalStatus.ReservedAndBound).length;
        this.sConfirmableCount = this.sTrailers.filter(x => x.Probability == TrailerPositionProbability.AtStation).length - this.sBookings.filter(x => x.Status == RentalStatus.ReservedAndBound).length;

        // Add extra rows
        this.injectSpaces(this.xlBookings, this.xlTrailers);
        this.injectSpaces(this.lBookings, this.lTrailers);
        this.injectSpaces(this.mBookings, this.mTrailers);
        this.injectSpaces(this.sBookings, this.sTrailers);

        this.disclosed = await this.Api.get<RentalInfo[]>("OneWay/GetDisclosedBookings", { locationId: this._locationId });
        this.isLoading = false;
    }

    private sortTrailers(a: RentalObjectPosition, b: RentalObjectPosition): number {
        var aBooking = this.bookings.find(x => x.Id == a.BookingId);
        var bBooking = this.bookings.find(x => x.Id == b.BookingId);

        if (aBooking && !bBooking) return -1;
        if (!aBooking && bBooking) return 1;
        if (aBooking && bBooking) {
            if (aBooking.QueueIndex < bBooking.QueueIndex) return -1;
            if (aBooking.QueueIndex > bBooking.QueueIndex) return 1;
        }

        if (a.FromTime < b.FromTime) return -1;
        if (a.FromTime > b.FromTime) return 1;

        return 0;
    }

    private injectSpaces(bookings: RentalInfo[], trailers: RentalObjectPosition[]) {

        for (var i = 0; i < bookings.length; i++) {
            if (i >= trailers.length) trailers.push(new RentalObjectPosition());
            else if (bookings[i].ObjectId && (i >= trailers.length || bookings[i].Id != trailers[i].BookingId)) {
                trailers.splice(i, 0, new RentalObjectPosition());
            } else if (bookings[i].PickupTime < trailers[i].RealFromTime) {
                trailers.splice(i, 0, new RentalObjectPosition());
            }
      }

      for (var i = 0; i < trailers.length; i++) {
        if (trailers[i].Probability == TrailerPositionProbability.Disabled) {
          trailers.splice(i, 0, new RentalObjectPosition());
          break;
        }
      }

        if (trailers.length > bookings.length) {
            for (var i = bookings.length; i < trailers.length; i++)
                bookings.push(new RentalInfo());
        }
    }

    public activateCustomer(customer: CustomerInfo) {
        this.activeCustomer = customer;
        this.customerActivated.emit(customer);
    }

    public deactivateCustomer(customer: CustomerInfo) {
        if (this.activeCustomer == customer) {
            this.activeCustomer = null;
            this.customerActivated.emit(null);
        }
    }

    public activateBooking(booking: RentalInfo) {
        this.activeBooking = booking;
        this.bookingActivated.emit(booking);
    }

    public deactivateBooking(booking: RentalInfo) {
        if (this.activeBooking == booking) {
            this.activeBooking = null;
            this.bookingActivated.emit(null);
        }
    }

    public openBooking(id: number) {
        RentalDialog.openBooking(this.Dialog, id);
        this.refresh();
    }

    public refresh() {
        this.loadData();
    }

    public swapTrailer(booking: RentalInfo) {
        RentalDialog.openBooking(this.Dialog, booking.Id, 1);
    }
}
